import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentUserRole: 'getCurrentRole',
    }),
    isAdmin() {
      return (
        this.currentUserRole === 'administrator' ||
        this.currentUserRole === 'master'
      );
    },
    isMaster() {
      return this.currentUserRole === 'master';
    },
    isOperator() {
      return this.currentUserRole === 'operator';
    },
  },
};
